import React from 'react';
import '../styles/Content.css';
import profileImage from '../assets/headshot.png';  // From src

const ProfileImage = () => {
  return (
    <div className="avatar">
      <img
        className="avatar-image"
        src={profileImage}
        alt="Ilias Pavlidakis"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
};

export default ProfileImage;
